module.exports = __webpack_public_path__ + "russierenouvelables/img/1-0.9e021cbe.webp";